import origDrop from "@assets/redesign/icons/drop.svg";
import wlpDrop from "@components/WLP202603/assets/redesign/icons/drop.svg";
import Icon from "@components/global/new/Icon/Icon";
import { useWatchNetwork } from "@mobx/services/http";
import { toColoredUser3 } from "@mobx/store/locations/types";
import usersStore from "@mobx/store/users";
import { setUsers } from "@store/users/actions";
import { useUsers } from "@utils/hooks/useUsers";
import { Collapse } from "antd";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { WLP202603 } from "../../../config";
import ColoredClient3 from "../ColoredClient3";
import styles from "./FilterClients.module.scss";

const drop = WLP202603 ? wlpDrop : origDrop;

const FilterClients3 = observer(() => {
  const { formatMessage } = useIntl();
  const clients = useUsers();
  const [show, setShow] = useState<boolean>(false);
  const dispatch = useDispatch(); // временно используем Redux чтобы не было путаницы со сторами юзеров
  useWatchNetwork(usersStore);

  const getUsers = async () => {
    const ok = await usersStore.updateUsers(); // потом будем использовать usersStore.users вместо useUsers
    if (!ok) return;
    dispatch(setUsers(usersStore.users));
  };

  useEffect(() => {
    if (usersStore.isLoaded || usersStore.isLoading) return;
    getUsers();
  }, [usersStore.isLoaded, usersStore.isLoading]);
  
  return (
    <Collapse
      className={styles.collapse}
      collapsible="icon"
      ghost
      activeKey={show ? "1" : ""}
      items={[
        {
          key: "1",
          label: <div className={styles.header} onClick={() => setShow(!show)}>
            <h5 className={styles.head}>
              {formatMessage({ id: "location.clients.title" })}
            </h5>
            <Icon
              className={cn(styles.collapseButton, {[styles.collapsed]: !show})}
              src={drop}
              noHover
            />
          </div>,
          children: <div>
            <div className={styles.clients}>
              {clients.map((client) => (
                <ColoredClient3 {...toColoredUser3(client)} key={client.id} />
              ))}
            </div>
          </div>,
          showArrow: false,
        },
      ]}
    />
  );
});

FilterClients3.displayName = "FilterClients3";

export default FilterClients3;
